import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme: any) => ({
  // Outer page wrapper
  mainContainer: {
    width: "100%",
    padding: theme.spacing(3),
    backgroundColor: "#ffffff",
    minHeight: "100vh",
    boxSizing: "border-box",
  },

  // Header / action buttons
  buttonContainer: {
    display: "flex",
    flexFlow: "row wrap",
    gap: 10,
    justifyContent: "flex-end",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      justifyContent: "flex-end",
      gap: 6,
    },
  },
  cancelButton: {
    backgroundColor: "transparent !important",
    color: "#d32f2f !important",
    borderColor: "#d32f2f !important",
    fontWeight: "600 !important",
    "&:hover": {
      backgroundColor: "rgba(211, 47, 47, 0.06) !important",
      borderColor: "#b71c1c !important",
    },
  },
  saveButton: {
    backgroundColor: "#4caf50 !important",
    color: "white !important",
    fontWeight: "600 !important",
    boxShadow: "0 2px 8px rgba(76, 175, 80, 0.3) !important",
    "&:hover": {
      backgroundColor: "#43a047 !important",
    },
    "&:disabled": {
      backgroundColor: "#e0e0e0 !important",
      color: "#9e9e9e !important",
      boxShadow: "none !important",
    },
  },

  // Section card (Paper) - mirrors Challenges editor SectionCard
  sectionCard: {
    border: "1px solid #e0e0e0",
    borderRadius: 12,
    marginBottom: theme.spacing(3),
    overflow: "hidden",
    transition: "border-color 0.3s, box-shadow 0.3s",
    backgroundColor: "#ffffff",
    "&:hover": {
      boxShadow: "0 2px 16px rgba(25, 118, 210, 0.08)",
    },
  },
  sectionHeader: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    padding: "16px 20px",
    borderBottom: "1px solid #eeeeee",
    borderLeft: "4px solid #1976d2",
    background: "linear-gradient(135deg, rgba(25, 118, 210, 0.05) 0%, transparent 100%)",
  },
  sectionStepBadge: {
    width: 32,
    height: 32,
    borderRadius: "50%",
    background: "linear-gradient(135deg, #1976d2, #1976d2cc)",
    color: "white",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 13,
    fontWeight: 700,
    flexShrink: 0,
    boxShadow: "0 2px 8px rgba(25, 118, 210, 0.4)",
  },
  sectionIcon: {
    color: "#1976d2",
    display: "flex",
    fontSize: 20,
  },
  sectionTitleText: {
    fontWeight: "700 !important",
    color: "#222 !important",
    lineHeight: "1.3 !important",
  },
  sectionSubtitleText: {
    color: "#777 !important",
    fontSize: "0.75rem !important",
  },
  sectionBody: {
    padding: theme.spacing(3),
  },

  // Form grid
  formGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
    gap: theme.spacing(2.5),
    alignItems: "start",
  },
  field: {
    width: "100%",
    minWidth: 0,
  },
  largeField: {
    width: "100%",
    minWidth: 0,
  },
  smallField: {
    width: "100%",
    minWidth: 0,
  },

  // View Weightage button row
  weightageRow: {
    marginTop: theme.spacing(2.5),
    display: "flex",
    justifyContent: "flex-start",
  },
  weightageButton: {
    minWidth: "180px !important",
  },

  // Milestone toolbar (header inside milestones section)
  milestoneToolbar: {
    display: "flex",
    flexFlow: "row wrap",
    justifyContent: "space-between",
    alignItems: "center",
    gap: theme.spacing(1.5),
    marginBottom: theme.spacing(2),
  },
  milestoneToolbarButtons: {
    display: "flex",
    gap: theme.spacing(1.5),
    flexWrap: "wrap",
  },
  addMilestoneButton: {
    backgroundColor: "#4caf50 !important",
    color: "white !important",
    fontWeight: "600 !important",
    boxShadow: "0 2px 6px rgba(76, 175, 80, 0.3) !important",
    "&:hover": {
      backgroundColor: "#43a047 !important",
    },
  },
  removeAllMilestoneButton: {
    backgroundColor: "#ef5350 !important",
    color: "white !important",
    fontWeight: "600 !important",
    boxShadow: "0 2px 6px rgba(239, 83, 80, 0.3) !important",
    "&:hover": {
      backgroundColor: "#e53935 !important",
    },
  },
  milestoneCount: {
    backgroundColor: "#e3f2fd",
    color: "#1565c0",
    padding: "4px 12px",
    borderRadius: 16,
    fontSize: "0.75rem",
    fontWeight: 700,
    border: "1px solid #90caf9",
  },

  // Milestone container & card
  milestoneList: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
  },
  milestoneCard: {
    position: "relative",
    border: "1px solid #e0e0e0",
    borderRadius: 10,
    padding: theme.spacing(2.5),
    backgroundColor: "#fafbfc",
    transition: "all 0.25s ease",
    "&:hover": {
      borderColor: "#90caf9",
      boxShadow: "0 2px 12px rgba(25, 118, 210, 0.08)",
      backgroundColor: "#ffffff",
    },
  },
  milestoneCardHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: theme.spacing(2),
    paddingBottom: theme.spacing(1),
    borderBottom: "1px dashed #e0e0e0",
  },
  milestoneTitle: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  milestoneBadge: {
    width: 28,
    height: 28,
    borderRadius: "50%",
    background: "linear-gradient(135deg, #1976d2, #42a5f5)",
    color: "white",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 12,
    fontWeight: 700,
  },
  milestoneTitleText: {
    fontWeight: "600 !important",
    color: "#333 !important",
    fontSize: "0.95rem !important",
  },
  milestoneFieldsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
    gap: theme.spacing(2),
  },
  milestoneRewardField: {
    gridColumn: "span 2",
    [theme.breakpoints.down("md")]: {
      gridColumn: "span 1",
    },
  },
  milestoneDescField: {
    gridColumn: "span 2",
    [theme.breakpoints.down("md")]: {
      gridColumn: "span 1",
    },
  },
  milestoneImageField: {
    gridColumn: "span 1",
  },
  milestoneImageCaption: {
    color: "#666 !important",
    fontWeight: "600 !important",
    fontSize: "0.75rem !important",
    marginBottom: "4px !important",
    display: "block !important",
  },
  imagePreview: {
    marginTop: 8,
    width: 60,
    height: 96,
    objectFit: "contain",
    borderRadius: 4,
    border: "1px solid #e0e0e0",
    padding: 2,
    backgroundColor: "white",
  },
  milestoneDeleteIcon: {
    color: "#e53935 !important",
    cursor: "pointer",
    padding: 6,
    borderRadius: 6,
    transition: "background 0.2s",
    "&:hover": {
      backgroundColor: "rgba(229, 57, 53, 0.08)",
    },
  },

  // Empty state
  emptyMilestones: {
    padding: theme.spacing(4),
    textAlign: "center",
    color: "#888",
    border: "1px dashed #cfd8dc",
    borderRadius: 8,
    backgroundColor: "#fafafa",
  },

  // Modal weightage view
  viewDataContainer: {
    width: "100%",
    display: "flex",
    flexFlow: "column nowrap",
    justifyContent: "start",
    alignItems: "stretch",
    gap: theme.spacing(1.5),
    marginBottom: theme.spacing(1),
  },
  weightageModalTitle: {
    fontWeight: "700 !important",
    color: "#1976d2 !important",
    marginBottom: "4px !important",
  },


}));

export default useStyles;
